import {useFormContext} from 'platform/components';

import {useCallback, use} from 'react';
import {FieldValues, UseFormReturn} from 'react-hook-form';

import {FormContextWithSubmit} from '../utils/FormContextWithSubmit';

interface UseFormContextWithSubmitReturnType<
  FormType extends FieldValues = Record<string, unknown>,
> {
  form: UseFormReturn<FormType>;
  onSubmit: () => void;
  onChange: () => void;
}

export function useFormContextWithSubmit<
  T extends FieldValues,
>(): UseFormContextWithSubmitReturnType<T> {
  const methods = useFormContext<T>();
  const context = use(FormContextWithSubmit);

  const handleOnSubmit = () => {
    context?.current?.onSubmit && context.current.onSubmit();
  };

  const handleOnChange = useCallback(() => {
    context.current?.onChange && context.current.onChange();
  }, [context]);

  return {
    // @ts-ignore - TODO: fix this error in
    form: methods,
    onSubmit: handleOnSubmit,
    onChange: handleOnChange,
  };
}
